import { render, staticRenderFns } from "./server-type.vue?vue&type=template&id=616634ec&scoped=true"
import script from "./server-type.vue?vue&type=script&lang=js"
export * from "./server-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616634ec",
  null
  
)

export default component.exports